module.exports = __webpack_public_path__ + "static/media/shopify10.3d40fab7.png";